(function () {
  if (window.__ufmDeliveryEstimator) {
    window.__ufmDeliveryEstimator.init(document);
    return;
  }

  var INVALID_POSTCODE_MESSAGE = 'Please enter a valid UK postcode.';
  var ERROR_MESSAGE = "We couldn't calculate delivery right now. Please try again or contact us.";
  var QUOTE_MESSAGE = 'Delivery to this postcode/product requires a quotation. Please contact our sales team.';
  var UNAVAILABLE_MESSAGE = 'Delivery is not currently available to this postcode.';
  var POSTCODE_PATTERN = /^(GIR0AA|(?:[A-PR-UWYZ][0-9][0-9A-HJKSTUW]?|[A-PR-UWYZ][A-HK-Y][0-9][0-9ABEHMNPRV-Y]?)[0-9][ABD-HJLNP-UW-Z]{2})$/;

  function normalizePostcode(value) {
    var compact = String(value || '').trim().toUpperCase().replace(/\s+/g, '');
    if (!POSTCODE_PATTERN.test(compact)) return '';
    return compact.slice(0, -3) + ' ' + compact.slice(-3);
  }

  function setMessage(result, message, state) {
    result.replaceChildren(document.createTextNode(message));
    result.dataset.state = state;
    result.hidden = false;
  }

  function formatPrice(rate) {
    var amount = Number(rate.price);
    if (!Number.isFinite(amount)) return null;
    if (amount === 0) return 'FREE';

    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: rate.currency || 'GBP'
      }).format(amount);
    } catch (error) {
      return (rate.currency || 'GBP') + ' ' + amount.toFixed(2);
    }
  }

  function renderRates(result, rates, postcode) {
    var heading = document.createElement('strong');
    var list = document.createElement('ul');
    heading.className = 'ufm-product-page__delivery-result-heading';
    heading.textContent = 'Delivery options for ' + postcode;
    list.className = 'ufm-product-page__delivery-rates';

    rates.forEach(function (rate) {
      if (!rate || !rate.title) return;
      var price = formatPrice(rate);
      if (price === null) return;

      var item = document.createElement('li');
      var title = document.createElement('span');
      var priceElement = document.createElement('span');

      item.className = 'ufm-product-page__delivery-rate';
      title.className = 'ufm-product-page__delivery-rate-title';
      priceElement.className = 'ufm-product-page__delivery-rate-price';
      if (Number(rate.price) === 0) priceElement.classList.add('is-free');
      title.textContent = rate.title;
      priceElement.textContent = price + (rate.tax_label ? ' ' + rate.tax_label : '');
      item.append(title, priceElement);
      list.appendChild(item);
    });

    if (!list.children.length) {
      setMessage(result, ERROR_MESSAGE, 'error');
      return;
    }

    result.replaceChildren(heading, list);
    result.dataset.state = 'available';
    result.hidden = false;
  }

  function renderResponse(result, payload, postcode) {
    var status = String(payload && payload.status || '').toLowerCase().replace(/-/g, '_');

    if ((status === 'available' || status === 'free') && Array.isArray(payload.rates)) {
      renderRates(result, payload.rates, postcode);
      return;
    }

    if (status === 'quote_required' || status === 'requires_quote') {
      setMessage(result, payload.message || QUOTE_MESSAGE, 'quote');
      return;
    }

    if (status === 'unavailable') {
      setMessage(result, payload.message || UNAVAILABLE_MESSAGE, 'unavailable');
      return;
    }

    setMessage(result, payload && payload.message || ERROR_MESSAGE, 'error');
  }

  function initEstimator(estimator) {
    if (estimator.dataset.ufmDeliveryBound === 'true') return;
    estimator.dataset.ufmDeliveryBound = 'true';

    var section = estimator.closest('.shopify-section') || estimator.closest('section');
    var form = estimator.querySelector('[data-ufm-delivery-form]');
    var postcodeInput = estimator.querySelector('[data-ufm-delivery-postcode]');
    var button = estimator.querySelector('[data-ufm-delivery-button]');
    var result = estimator.querySelector('[data-ufm-delivery-result]');
    var buttonText = button ? button.textContent.trim() : 'Calculate Delivery';
    var activeRequest = null;

    if (!section || !form || !postcodeInput || !button || !result) return;

    function getProductForm() {
      var selector = estimator.dataset.productFormSelector;
      if (selector) {
        try {
          var selectedForm = section.querySelector(selector);
          if (selectedForm) return selectedForm;
        } catch (error) {
          // Fall through to the standard Shopify product-form lookup.
        }
      }
      return section.querySelector('form[action*="/cart/add"]');
    }

    function syncVariantId() {
      var productForm = getProductForm();
      var variantInput = productForm && productForm.querySelector('[name="id"]');
      estimator.dataset.variantId = variantInput ? variantInput.value : '';
      return estimator.dataset.variantId;
    }

    function resetResult() {
      if (activeRequest) activeRequest.abort();
      activeRequest = null;
      button.disabled = false;
      button.textContent = buttonText;
      result.hidden = true;
      result.replaceChildren();
      delete result.dataset.state;
    }

    section.addEventListener('change', function (event) {
      if (event.target.matches('[name="id"], .hp-select')) syncVariantId();
      if (event.target.matches('[name="id"], [name="quantity"], .hp-select')) resetResult();
    });

    section.addEventListener('input', function (event) {
      if (event.target.matches('[name="quantity"]')) resetResult();
    });

    section.addEventListener('click', function (event) {
      if (event.target.closest('[data-ufm-qty-action], .hp-qty-btn')) resetResult();
    });

    postcodeInput.addEventListener('blur', function () {
      var postcode = normalizePostcode(postcodeInput.value);
      if (postcode) postcodeInput.value = postcode;
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (activeRequest) return;

      var postcode = normalizePostcode(postcodeInput.value);
      var productForm = getProductForm();
      var quantityInput = productForm && productForm.querySelector('[name="quantity"]');
      var quantity = quantityInput ? Number.parseInt(quantityInput.value, 10) : 1;
      var variantId = syncVariantId();

      if (!postcode) {
        setMessage(result, INVALID_POSTCODE_MESSAGE, 'error');
        postcodeInput.setAttribute('aria-invalid', 'true');
        postcodeInput.focus();
        return;
      }

      postcodeInput.value = postcode;
      postcodeInput.removeAttribute('aria-invalid');

      if (!variantId || !Number.isInteger(quantity) || quantity < 1) {
        setMessage(result, ERROR_MESSAGE, 'error');
        return;
      }

      var request = new AbortController();
      activeRequest = request;
      button.disabled = true;
      button.textContent = 'Calculating...';
      setMessage(result, 'Calculating delivery options...', 'loading');

      fetch(estimator.dataset.proxyUrl || '/apps/delivery-estimate', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          variant_id: variantId,
          quantity: quantity,
          postcode: postcode,
          country: 'GB'
        }),
        signal: request.signal
      }).then(function (response) {
        if (!response.ok) throw new Error('Delivery estimate request failed');
        return response.json();
      }).then(function (payload) {
        renderResponse(result, payload, postcode);
      }).catch(function (error) {
        if (error.name !== 'AbortError') setMessage(result, ERROR_MESSAGE, 'error');
      }).finally(function () {
        if (activeRequest === request) {
          activeRequest = null;
          button.disabled = false;
          button.textContent = buttonText;
        }
      });
    });
  }

  function initEstimators(root) {
    if (root.matches && root.matches('[data-ufm-delivery-estimator]')) initEstimator(root);
    root.querySelectorAll('[data-ufm-delivery-estimator]').forEach(initEstimator);
  }

  window.__ufmDeliveryEstimator = {
    init: initEstimators
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initEstimators(document);
    });
  } else {
    initEstimators(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initEstimators(event.target);
  });
})();
